module.exports = __webpack_public_path__ + "static/1-702edf2c92d138db20ef129b34da8519.jpeg";